import { MaskedLine, Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, highlight, description, children }) => (
  <section className="relative overflow-hidden bg-slate-50 pt-36 pb-16 sm:pt-44 sm:pb-20" data-testid="page-hero">
    <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-emerald-100/60" />
    <div className="pointer-events-none absolute -left-24 top-40 h-64 w-64 rounded-full bg-sky-100/60" />
    <div className="container-site relative">
      {eyebrow && (
        <Reveal y={16}>
          <span className="eyebrow" data-testid="page-hero-eyebrow">{eyebrow}</span>
        </Reveal>
      )}
      <h1 className="mt-4 max-w-4xl text-4xl font-bold tracking-tighter leading-[1.08] sm:text-5xl lg:text-6xl" data-testid="page-hero-title">
        <MaskedLine delay={0.05}>{title}</MaskedLine>
        {highlight && (
          <MaskedLine delay={0.18}>
            <span className="text-emerald-500">{highlight}</span>
          </MaskedLine>
        )}
      </h1>
      {description && (
        <Reveal delay={0.3}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed sm:text-lg" data-testid="page-hero-description">
            {description}
          </p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
